import cx from 'classnames';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  addCustomRecipientMessage,
  removeCustomRecipientMessage,
} from '~/CreateFabricGreetingCard/api/recipientMessages';
import {
  RECIPIENT_CARD_SELECTED,
  selectRecipientMessage,
  selectRecipientSelected,
  UPDATE_INDIVIDUAL_MESSAGE,
} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {MessageInput} from '~/CreateFabricGreetingCard/routes/RecipientsMessage/components/MessageInput/MessageInput';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {EyeIcon} from '~library/svg/EyeIcon';
import {tanzanite} from '~libSass/base/_exports.sass';

import './IndividualMessage.sass';

const RadioMessageType = ({type, isSelected, onClick}) => {
  const label = {
    custom: 'Customize message',
    global: 'Global message',
  };
  return (
    <Button
      type="button"
      variant="transparent"
      className="individual-message__card__type"
      onClick={() => !isSelected && onClick(type)}
      data-qa-id={`${type}-message-select`}
    >
      <div className={`message-type__radio ${isSelected ? 'selected' : ''}`} />
      <Typography
        variant="paragraph3"
        className={`individual-message__card__type__label ${isSelected ? 'selected' : ''}`}
        color="charcoal"
      >
        {label[type]}
      </Typography>
    </Button>
  );
};

export const IndividualMessage = ({guest, isMobile, onPreview, globalMessage}) => {
  const [isCustomMessage, setCustomMessage] = useState(false);
  const [inputOpened, setInputOpened] = useState(false);
  const recipientMessage = useSelector(selectRecipientMessage(guest?.guest_id));
  const recipientSelected = useSelector(selectRecipientSelected);
  const dispatch = useDispatch();

  const selectGuest = useCallback(
    (guestId) => {
      dispatch({type: RECIPIENT_CARD_SELECTED, payload: guestId});
    },
    [dispatch]
  );

  const selectCustomMessage = useCallback(() => {
    selectGuest(guest.guest_id);
    dispatch({
      type: UPDATE_INDIVIDUAL_MESSAGE,
      payload: {[guest.guest_id]: globalMessage},
    });
    setInputOpened(true);
    setCustomMessage(true);
  }, [selectGuest, guest.guest_id, dispatch, globalMessage]);

  const selectGlobalMessage = useCallback(() => {
    setCustomMessage(false);
    dispatch(removeCustomRecipientMessage(guest.guest_id));
  }, [dispatch, guest.guest_id]);

  const onMessageChange = useCallback(
    (message) => {
      dispatch({
        type: UPDATE_INDIVIDUAL_MESSAGE,
        payload: {[guest.guest_id]: message},
      });
    },
    [dispatch, guest.guest_id]
  );

  const onDoneMessageClick = useCallback(() => {
    dispatch(addCustomRecipientMessage([guest.guest_id]));
  }, [dispatch, guest.guest_id]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  useEffect(() => {
    setCustomMessage(typeof recipientMessage === 'string');
  }, [dispatch, recipientMessage]);

  return (
    <div
      className={cx('individual-message', {
        selected: guest.guest_id === recipientSelected,
      })}
      onClick={() => selectGuest(guest.guest_id)}
      data-qa-id={`recipient-message_row-${guest.guest_id}`}
      onKeyUp={null}
      role="button"
      tabIndex={0}
    >
      <div className="individual-message__header">
        <Typography variant="paragraph3" className="individual-message__guest" color="charcoal">
          {guest.name}
        </Typography>
        {isMobile && (
          <Button
            type="button"
            variant="transparent"
            className="individual-message__header__preview-button"
            data-qa-id="preview-btn"
            onClick={onPreview}
          >
            <EyeIcon color={tanzanite} ratio={0.563} /> Preview
          </Button>
        )}
      </div>
      <div className="individual-message__card">
        <RadioMessageType
          type="global"
          isSelected={!isCustomMessage}
          onClick={selectGlobalMessage}
        />
        <RadioMessageType
          type="custom"
          isSelected={isCustomMessage}
          onClick={selectCustomMessage}
        />
      </div>
      {isCustomMessage && (
        <MessageInput
          dataQaId="message-input"
          message={recipientMessage}
          onMessageChange={onMessageChange}
          onDoneClick={onDoneMessageClick}
          initialState={!recipientMessage || inputOpened}
        />
      )}
    </div>
  );
};
